<template>
  <div id="campaign-track">
    <div class="blog">
      <div class="title-blog" style="width:100%;margin-bottom:20px;">TRACK
        <div class="searchContainer" style="top:10px;right:30px;margin-top:5px;width:300px;float:right;margin-right:50px;position:absolute">
            <i class="md-icon material-icons searchIcon">search</i>
            <input
              v-model="search"
              class="searchBox"
              type="search"
              name="search"
              placeholder="Search campaign."
              v-on:input="searchOnTable"

            >
          </div>
      </div>
      <!-- <div class="header-blog">
        <div style="width:30%">
          
        </div>

      </div> -->

      <md-tabs>
        <md-tab id="tab-home" md-label="Track camapaign">
          <trackCampaign :keyword="keyword"></trackCampaign>
        </md-tab>
        <md-tab id="tab-pages" md-label="Delivery Awards to Customer">
          <sendToReward :keyword="keyword"></sendToReward>
        </md-tab>
        <md-tab id="tab-posts" md-label="Compare cost and profits">
          <compareCostAndProfits :keyword="keyword"></compareCostAndProfits>
        </md-tab>
      </md-tabs>

      
    </div>


  </div>
</template>

<script>
// const toLower = text => {
//   return text.toString().toLowerCase();
// };

// const searchByName = (items, term) => {
//   if (term) {
//     return items.filter(item =>
//       toLower(item.campaign_title).includes(toLower(term))
//     );
//   }

//   return items;
// };



import trackCampaign from "@/components/campaign/track/trackCampaign";
import sendToReward from "@/components/campaign/track/sendToReward";
import compareCostAndProfits from "@/components/campaign/track/compareCostAndProfits";

export default {
  name: "CampaignReport",
  components: {
    trackCampaign,
    sendToReward,
    compareCostAndProfits
  },
  data: () => ({
    showDetail: false,
    loading: false,
    search: null,
    searched: [],
    campaign: {},
    keyword: ""
  }),
  methods: {

    searchOnTable() {
      this.keyword = this.search;
      // const response = this.searchedTemp.filter(word => {
      //   const str = word.campaign_title;
      //   // const str = word.code + word.first_name+ word.last_name+ word.last_name;
      //   return str.toUpperCase().indexOf(this.search.toUpperCase()) !== -1;
      // });
      // this.searched = response;

    },


  },
  created() {

  }
};
</script>

<style lang="scss" scoped>
#campaign-track {
  .blog {
    background: white;
    padding-left: 10px;
    .title-blog {
      padding-left: 30px;
      font-size: 18px;
      font-weight: bold;
      color: #797979;
      font-family: lato;
      padding-top: 20px;
    }
    .header-blog {
      padding: 18px 30px 20px 30px;
      display: -webkit-box;
      width: 100%;
      .btn-create {
        width: 120px;
        height: 32px;
        -webkit-box-shadow: unset;
        box-shadow: unset;
        font-family: lato;
        font-size: 12px;
        font-weight: 700;
        border-radius: 3px;
        .plus {
          margin-right: 20px;
        }
      }
      .md-button.md-raised:not([disabled]) {
        box-shadow: unset;
      }
    }
    
    .searchContainer {
      display: inline-flex;
      flex: 1 1 300px;
      position: relative;
      border-radius: 5px;
      overflow: hidden;
      width: 360px;
      height: 36px;
      .md-icon {
        color: #c0c0c0 !important;
      }
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.16), 0 0 0 rgba(0, 0, 0, 0),
        0 1px 1px -2px rgba(0, 0, 0, 0);
      .searchIcon {
        padding-left: 20px;
        width: 40px;
      }

      .searchBox {
        font-size: 14px;
        border: 0;
        padding: 0.5rem 0.5rem 0.5rem 10px;
        flex: 1;
        outline: none;
        &::-webkit-input-placeholder {
          color: #c0c0c0;
        }
        &::-ms-clear {
          display: none;
        }
      }
    }
  }
}

.md-table {
  height: calc(100vh - 100px);
}
</style>
